import { useAuth } from "../context/AuthContext";

export const ROLE_BASE = { pengguna: "/pengguna", inspector: "/inspector", admin: "/admin" };

export function useRoleBase() {
  const { user } = useAuth();
  return ROLE_BASE[user?.role] || "";
}
